import t from "module/translations";
import { TrainingType } from "module/training/types";

export const getTrainingTypeTranslation = (state: TrainingType): string =>
  ({
    [TrainingType.initial]: t.competencyManagement.training.type.initialText,
    [TrainingType.refresher]:
      t.competencyManagement.training.type.refresherText,
  }[state]);
